__turbopack_context__.v({
  "contactSection": "LandingView-module-scss-module__B5OGDa__contactSection",
  "ctaWrapper": "LandingView-module-scss-module__B5OGDa__ctaWrapper",
  "faqLink": "LandingView-module-scss-module__B5OGDa__faqLink",
  "faqList": "LandingView-module-scss-module__B5OGDa__faqList",
  "faqSection": "LandingView-module-scss-module__B5OGDa__faqSection",
  "root": "LandingView-module-scss-module__B5OGDa__root",
});
